import { YearMonthPickerDesktop } from '@/domain/termine/components/YearMonthPicker/desktop/YearMonthPickerDesktop';
import { Calendar } from '@/domain/termine/features/Calendar/Grid/Calendar';
import { YearMonthParams } from '@/domain/termine/type';
import { buttonVariants } from '@/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Outlet, useParams } from 'react-router-dom';
import { faPlusLarge } from '@fortawesome/pro-solid-svg-icons';
import { cn } from '@/lib/utils';
import { CalendarSelect } from '@/domain/termine/features/Calendar/Grid/CalendarSelect/CalendarSelect';

export function TermineDesktopContent() {
  const { year, month } = useParams<YearMonthParams>();
  const currentMonthAndYear: YearMonthParams = { year, month };

  return (
    <>
      <div className="flex gap-2 items-center justify-between pb-6 w-full">
        <div>
          <YearMonthPickerDesktop currentMonthAndYear={currentMonthAndYear} />
        </div>
        <div className="flex justify-end gap-2 items-center">
          <CalendarSelect />
          <Link
            className={cn(buttonVariants({ variant: 'default', size: 'icon' }))}
            to={`/termine/uebersicht/${year}/${month}/create`}>
            <FontAwesomeIcon icon={faPlusLarge} className="font-bold" />
          </Link>
        </div>
      </div>
      <Calendar />
      <Outlet />
    </>
  );
}
